import {
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";
import React, { Dispatch, RefObject, useState } from "react";
import { FormInput } from "../../../lib/workout-form/transformers";
import { Action, FormInputs } from "../../../reducers/workoutReducer";

type Props = {
  dispatch: Dispatch<Action>;
  loading: boolean;
  numberOfPlaces: FormInput;
  handleErrorRefs: RefObject<(() => void)[]>;
};

const NumberOfPlacesInput = ({
  handleErrorRefs,
  dispatch,
  loading,
  numberOfPlaces,
}: Props) => {
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const handleError = () => {
    setError(numberOfPlaces.error);
    setMessage(numberOfPlaces.message);
  };
  handleErrorRefs.current?.push(handleError);

  return (
    <FormControl fullWidth>
      <InputLabel htmlFor="numberOfPlaces"></InputLabel>
      <TextField
        disabled={loading}
        inputProps={{
          style: { textAlign: "center" },
          min: 0,
        }}
        type="number"
        id="numberOfPlaces"
        value={numberOfPlaces.input}
        label="Deltagare"
        onChange={(e) =>
          dispatch({
            type: FormInputs.numberOfPlaces,
            payload: e.target.value,
          })
        }
        onBlur={handleError}
        error={error}
        helperText={message}
      />
    </FormControl>
  );
};

export default NumberOfPlacesInput;
